import { useContext } from 'react';
import type { FieldValues, UseFormResponse } from '../useForm/types';
import { createFormContext } from '../useForm/utils';

const useFormMethods = <T extends FieldValues = FieldValues>(): UseFormResponse<T> => {
  const FormContext = createFormContext<T>();

  return useContext(FormContext);
};

export default useFormMethods;
